// State Object for ShopsDistribution. Dont directly mutate it anywhere except the shops/mutations.js file
export const shopsDistributionState = {
  shopsData: null,
  shopList: null,
  shopDetails: null
};
